module.exports = import("https://cdn.socket.io/4.3.2/socket.io.esm.min.js");;